/* PDP description / details panel behaviour (sections/pdp-description.liquid).
 * Moved out of the section's inline script 2026-11-02 (perf): 23.6 KB of inline JS on every PDP
 * view is now one cached file. Same code; the only changes are how the initial roots and the
 * section id are found (no document.currentScript / Liquid in a static asset) and the compact
 * diagram map. Loaded with defer, so it runs after parsing, before DOMContentLoaded.
 */
  (function () {
    /* All of the behaviour below lives in boot(root) so it can be re-run after the
      section is re-rendered for a sibling product (see the swatch swap at the bottom of this
      script). Nothing in here is delegated from document onto a stable ancestor — every
      listener binds directly to nodes inside `root` — so replacing the markup without calling
      boot() again would leave the panel looking correct and doing nothing. */
    function boot(root) {
      if (!root || root.__ddBooted) return;
      root.__ddBooted = true;

    /* ================= Description read-more ================= */
    var content = root.querySelector('[data-desc-content]');
    var toggle = root.querySelector('[data-desc-toggle]');
    if (content && toggle) {
      var moreEl = toggle.querySelector('[data-desc-more]');
      var lessEl = toggle.querySelector('[data-desc-less]');
      var checkShort = function () {
        if (content.classList.contains('is-expanded')) return;
        content.classList.toggle('is-short', content.scrollHeight <= content.clientHeight + 4);
      };
      checkShort();
      window.addEventListener('resize', checkShort);
      toggle.addEventListener('click', function () {
        var expanded = content.classList.toggle('is-expanded');
        if (expanded) {
          content.style.maxHeight = content.scrollHeight + 'px';
          setTimeout(function () {
            if (content.classList.contains('is-expanded')) content.style.maxHeight = 'none';
          }, 380);
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
          requestAnimationFrame(function () { content.style.maxHeight = ''; });
        }
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        moreEl.hidden = expanded;
        lessEl.hidden = !expanded;
      });
    }

    /* ================= Details: desktop tablist (APG) ================= */
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-dd-tab]'));
    var blocks = Array.prototype.slice.call(root.querySelectorAll('[data-dd-block]'));
    /* Sync every video/gallery to what is actually visible: galleries pause hidden slides, panel media boxes (Durability/Care/Delivery) only play while their panel shows. */
    function syncMedia() {
      syncAllGals();
      Array.prototype.slice.call(root.querySelectorAll('.pdp-dd__panel-media video')).forEach(function (v) {
        var block = v.closest('[data-dd-block]');
        var show = block && block.offsetParent !== null;
        if (show && inViewport(v)) {
          armVideo(v);
          try { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } catch (e) {}
        } else if (v.pause) {
          v.pause();
        }
      });
    }
    function activateTab(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      var key = tab.getAttribute('data-dd-tab');
      blocks.forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-dd-block') === key);
      });
      syncMedia();
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, idx) {
      tab.addEventListener('click', function () { activateTab(tab, false); });
      tab.addEventListener('keydown', function (e) {
        /* arrow-steps skip hidden tabs (Spare parts stays hidden until products load) */
        var next = null;
        var j;
        if (e.key === 'ArrowRight') {
          j = idx;
          do { j = (j + 1) % tabs.length; } while (tabs[j].hidden && j !== idx);
          next = tabs[j];
        } else if (e.key === 'ArrowLeft') {
          j = idx;
          do { j = (j - 1 + tabs.length) % tabs.length; } while (tabs[j].hidden && j !== idx);
          next = tabs[j];
        } else if (e.key === 'Home') {
          next = tabs[0];
        } else if (e.key === 'End') {
          j = tabs.length - 1;
          while (j > 0 && tabs[j].hidden) j--;
          next = tabs[j];
        }
        if (next && !next.hidden) { e.preventDefault(); activateTab(next, true); }
      });
    });

    /* ================= Details: mobile accordion — max ONE dropdown open at a time ================= */
    var accBtns = Array.prototype.slice.call(root.querySelectorAll('[data-dd-acc]'));
    var scrollOffset = parseInt(root.getAttribute('data-scroll-offset'), 10) || 70;
    /* The description is part of the same group: it starts open, and any spec row that opens closes it (and vice versa). */
    var descBlock = root.querySelector('[data-desc-block]');
    var descAcc = root.querySelector('[data-desc-acc]');
    function closeDesc() {
      if (!descBlock) return;
      descBlock.classList.remove('is-open');
      if (descAcc) descAcc.setAttribute('aria-expanded', 'false');
    }
    accBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var block = root.querySelector('[data-dd-block="' + btn.getAttribute('data-dd-acc') + '"]');
        if (!block) return;
        var open = block.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          /* opening this one closes every other dropdown, description included */
          blocks.forEach(function (b) {
            if (b !== block) b.classList.remove('is-open');
          });
          closeDesc();
          accBtns.forEach(function (b2) {
            if (b2 !== btn) b2.setAttribute('aria-expanded', 'false');
          });
          /* A dropdown ABOVE closing shrinks the page and would leave the viewport past the opened one — chase-scroll the tapped header under the sticky menu (see chaseTo). */
          chaseTo(btn);
          /* Materials: ~1s AFTER the scroll has settled, the first media bar "budges" down once to show it can be opened. */
          if (btn.getAttribute('data-dd-acc') === '2') {
            setTimeout(nudgeActiveSet, 1000);
          }
        }
        setTimeout(syncMedia, 280); // after the collapse settles, start/stop panel videos
      });
    });

    /* Description header (mobile): toggles like any other row, and opening it closes the rest. */
    if (descBlock && descAcc) {
      descAcc.addEventListener('click', function () {
        var open = descBlock.classList.toggle('is-open');
        descAcc.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          blocks.forEach(function (b) { b.classList.remove('is-open'); });
          accBtns.forEach(function (b2) { b2.setAttribute('aria-expanded', 'false'); });
          chaseTo(descAcc);
        }
        setTimeout(syncMedia, 280);
      });
    }

    /* ================= Materials sub-menu (pills): one category shown at a time ================= */
    var matTabs = Array.prototype.slice.call(root.querySelectorAll('[data-mat-tab]'));
    var matGroups = Array.prototype.slice.call(root.querySelectorAll('[data-mat-group]'));
    function activateMatTab(tab, focus) {
      matTabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      var key = tab.getAttribute('data-mat-tab');
      matGroups.forEach(function (g) {
        g.classList.toggle('is-active', g.getAttribute('data-mat-group') === key);
      });
      syncMedia();
      if (focus) tab.focus();
    }
    matTabs.forEach(function (tab, idx) {
      tab.addEventListener('click', function () {
        activateMatTab(tab, false);
        /* mobile: give the newly shown category's first media set its nudge too */
        if (window.innerWidth < 768) setTimeout(nudgeActiveSet, 350);
      });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = matTabs[(idx + 1) % matTabs.length];
        else if (e.key === 'ArrowLeft') next = matTabs[(idx - 1 + matTabs.length) % matTabs.length];
        else if (e.key === 'Home') next = matTabs[0];
        else if (e.key === 'End') next = matTabs[matTabs.length - 1];
        if (next) { e.preventDefault(); activateMatTab(next, true); }
      });
    });

    /* ================= cm/in switch — market default wins each visit; a manual choice is kept only for the current session (sessionStorage). Both sets are server-rendered. ================= */
    var unitBtns = Array.prototype.slice.call(root.querySelectorAll('[data-unit-btn]'));
    function setUnit(u, persist) {
      root.classList.toggle('pdp-dd--unit-cm', u === 'cm');
      root.classList.toggle('pdp-dd--unit-in', u === 'in');
      unitBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-unit-btn') === u ? 'true' : 'false');
      });
      if (persist) {
        try { sessionStorage.setItem('pdpUnitPref', u); } catch (e) {}
      }
    }
    unitBtns.forEach(function (b) {
      b.addEventListener('click', function () { setUnit(b.getAttribute('data-unit-btn'), true); });
    });
    /* The mini toggle track flips to the other unit */
    var unitTrack = root.querySelector('[data-unit-toggle]');
    if (unitTrack) {
      unitTrack.addEventListener('click', function () {
        setUnit(root.classList.contains('pdp-dd--unit-in') ? 'cm' : 'in', true);
      });
    }
    try {
      var pref = sessionStorage.getItem('pdpUnitPref');
      if (pref === 'cm' || pref === 'in') setUnit(pref, false);
    } catch (e) {}

    /* ================= Diagram zoom — click opens the 1:1 popup (full height, square) ================= */
    var zoomEl = null;
    function closeZoom() {
      if (zoomEl) { zoomEl.remove(); zoomEl = null; document.body.style.overflow = ''; }
    }
    function openZoom(src) {
      closeZoom();
      zoomEl = document.createElement('div');
      zoomEl.className = 'pdp-dd__zoom';
      zoomEl.setAttribute('role', 'dialog');
      zoomEl.setAttribute('aria-label', 'Dimension diagram');
      var img = document.createElement('img');
      img.src = src;
      img.alt = '';
      zoomEl.appendChild(img);
      zoomEl.addEventListener('click', closeZoom); // click anywhere closes
      document.body.appendChild(zoomEl);
      document.body.style.overflow = 'hidden';
    }
    Array.prototype.slice.call(root.querySelectorAll('[data-diagram-full]')).forEach(function (btn) {
      btn.addEventListener('click', function () { openZoom(btn.getAttribute('data-diagram-full')); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && zoomEl) closeZoom();
    });

    /* ================= Variant-adaptive dimensions ================= Two JSON maps are rendered by the Liquid above, both keyed by variant id: [data-dd-diagram-map] - per-variant diagram URLs plus a product-level "default" [data-dd-spec-map]    - per-variant VALUES for the spec rows The table and the diagram are server-rendered for whichever variant Shopify served, and the selector switches without a reload, so both would otherwise stay frozen on that variant. On any option change inside the PDP variant selector (<variant-selects> in the product module) the selected variant is resolved from the selector's OWN variants JSON - the same checked-inputs matching the theme engine uses - and both are retargeted. Generic for ANY option structure (Seat height on stools, Length on tables and benches, ...) because nothing here knows the option names. A product with neither map leaves this block inert. */
    (function () {
      var mapEl = root.querySelector('[data-dd-diagram-map]');
      var specEl = root.querySelector('[data-dd-spec-map]');
      if (!mapEl && !specEl) return;
      var map = null;
      var specMap = null;
      if (mapEl) { try { map = JSON.parse(mapEl.textContent); } catch (err) { map = null; } }
      if (specEl) { try { specMap = JSON.parse(specEl.textContent); } catch (err) { specMap = null; } }
      if (!map && !specMap) return;

      /* Only these rows follow the variant. Country of origin, Designer and the taxonomy rows are product-level - they carry a data-spec-key too, and are deliberately absent from this list so they are never touched. */
      var SPEC_KEYS = ['width', 'depth', 'height', 'seat', 'armrest', 'weight', 'maxload', 'color', 'material'];

      function applySpecs(id) {
        if (!specMap) return;
        var entry = specMap[String(id)];
        if (!entry) return;
        SPEC_KEYS.forEach(function (key) {
          var row = root.querySelector('.pdp-dd__dims [data-spec-key="' + key + '"]');
          if (!row) return;
          var val = entry[key];
          if (!val) { row.hidden = true; return; } // this variant has no such measurement
          row.hidden = false;
          var cm = row.querySelector('[data-u-cm]');
          var inch = row.querySelector('[data-u-in]');
          if (cm) cm.textContent = val.cm;
          if (inch) inch.textContent = val['in'];
        });
      }

      function applyEntry(entry) {
        if (!map) return;
        ['cm', 'in'].forEach(function (unit) {
          var data = (entry && entry[unit]) || (map['default'] && map['default'][unit]);
          if (!data) return;
          /* 2026-11-02 perf: the map now carries ONE URL per unit, the 1600 px zoom crop (it used
             to spell out all four widths, 11.8 KB on the 18-variant customise page). The smaller
             widths are the same URL with Shopify's width parameter swapped. */
          if (typeof data === 'string') {
            var at = function (w) { return data.replace(/([?&])width=\d+/, '$1width=' + w); };
            data = { s400: at(400), s600: at(600), s800: at(800), z: data };
          }
          Array.prototype.slice.call(root.querySelectorAll('[data-dd-zoom-' + unit + ']')).forEach(function (btn) {
            btn.setAttribute('data-diagram-full', data.z);
            var img = btn.querySelector('img');
            if (img) {
              img.src = data.s800;
              img.srcset = data.s400 + ' 400w, ' + data.s600 + ' 600w, ' + data.s800 + ' 800w';
            }
          });
        });
      }

      function norm(v) { return (v || '').toLowerCase().replace(/\s+/g, ' ').trim(); }

      function resolveVariant(selector) {
        var dataEl = selector.querySelector('script[type="application/json"]');
        if (!dataEl) return null;
        var variants;
        try { variants = JSON.parse(dataEl.textContent); } catch (err) { return null; }
        var checked = selector.querySelectorAll('.pm__option-input:checked');
        var values = Array.prototype.map.call(checked, function (i) { return norm(i.value); });
        if (!values.length) return null;
        /* exact match first (every checked value present AND same option count) ... */
        for (var n = 0; n < variants.length; n++) {
          var opts = (variants[n].options || []).map(norm);
          if (opts.length === values.length && values.every(function (v) { return opts.indexOf(v) > -1; })) {
            return variants[n];
          }
        }
        /* ... then partial (some options may be visualized outside the selector, e.g. connected-products swatches that link to sibling products). */
        for (var m = 0; m < variants.length; m++) {
          var o2 = (variants[m].options || []).map(norm);
          if (values.every(function (v) { return o2.indexOf(v) > -1; })) return variants[m];
        }
        return null;
      }

      document.addEventListener('change', function (e) {
        if (!e.target || !e.target.closest) return;
        var selector = e.target.closest('variant-selects');
        if (!selector) return;
        setTimeout(function () {
          var v = resolveVariant(selector);
          if (!v) return;
          applySpecs(v.id);
          if (map) applyEntry(map.variants ? map.variants[String(v.id)] : null);
        }, 0);
      });
    })();

    /* ================= Chase-scroll: park an element under the sticky menu ================= Runs in parallel with collapses/expands: each frame re-measures where the element sits and eases toward it. Used by the accordion and the media drawers. Mobile only. */
    function chaseTo(el) {
      var startY = window.pageYOffset;
      var t0 = null;
      var DUR = 280;
      var chase = function (ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / DUR, 1);
        var ease = 1 - Math.pow(1 - p, 3); // easeOutCubic — fast start, soft landing
        var target = Math.max(el.getBoundingClientRect().top + window.pageYOffset - scrollOffset, 0);
        window.scrollTo(0, startY + (target - startY) * ease);
        if (p < 1) requestAnimationFrame(chase);
      };
      requestAnimationFrame(chase);
    }

    /* ================= Lazy videos: ZERO network until needed ================= Every video renders with preload="none", a poster and NO src — nothing is fetched at page load. A video is "armed" (src attached) and played only when it is BOTH structurally visible (its tab/drawer open) AND inside the viewport; scrolling it out pauses it. The source is picked by screen width: phones get the 480p encode (720p fallback), desktop 720p (1080p fallback) — the 1080p file is never sent to mobile. */
    var vidsInView = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
    var vio = null;
    function inViewport(v) {
      if (!vio || !vidsInView) return true; // no IO support: behave like before
      return vidsInView.has(v);
    }
    function armVideo(v) {
      if (!v.hasAttribute('data-lazy-video') || v.getAttribute('src')) return;
      var src = window.innerWidth < 768
        ? v.getAttribute('data-src-sd') || v.getAttribute('data-src-hd')
        : v.getAttribute('data-src-hd') || v.getAttribute('data-src-fhd');
      if (!src) src = v.getAttribute('data-src-fhd');
      if (src) v.setAttribute('src', src);
    }
    if ('IntersectionObserver' in window && vidsInView) {
      vio = new IntersectionObserver(function (entries) {
        var anyIn = false;
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            vidsInView.add(en.target);
            anyIn = true;
          } else {
            vidsInView.delete(en.target);
            if (en.target.pause) en.target.pause();
          }
        });
        if (anyIn) syncMedia(); // (re)start whichever of them should be playing
      }, { rootMargin: '120px' });
      Array.prototype.slice.call(root.querySelectorAll('video[data-lazy-video]')).forEach(function (v) {
        vio.observe(v);
      });
    }

    /* ================= Shared 1:1 galleries (mobile drawers + desktop group boxes) ========= Arrows mirror the position; only the visible slide's video plays, and drawer galleries only play while their drawer is open. */
    var galSyncs = [];
    Array.prototype.slice.call(root.querySelectorAll('[data-gal]')).forEach(function (gal) {
      var track = gal.querySelector('[data-gal-track]');
      var prev = gal.querySelector('[data-gal-prev]');
      var next = gal.querySelector('[data-gal-next]');
      var slides = Array.prototype.slice.call(track.children);
      function gIdx() {
        return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(track.clientWidth, 1))));
      }
      function playable() {
        var dr = gal.closest('[data-media-drawer]');
        if (dr && !dr.classList.contains('is-open')) return false;
        return !!gal.offsetParent; // false while any ancestor is display:none
      }
      function sync() {
        var i0 = gIdx();
        if (prev) prev.hidden = i0 === 0;
        if (next) next.hidden = i0 >= slides.length - 1;
        var ok = playable();
        slides.forEach(function (s, i) {
          Array.prototype.slice.call(s.querySelectorAll('video')).forEach(function (v) {
            if (ok && i === i0 && inViewport(v)) {
              armVideo(v);
              try { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } catch (e) {}
            } else if (v.pause) {
              v.pause();
            }
          });
        });
      }
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = null; sync(); });
      });
      if (prev) prev.addEventListener('click', function () {
        track.scrollTo({ left: (gIdx() - 1) * track.clientWidth, behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollTo({ left: (gIdx() + 1) * track.clientWidth, behavior: 'smooth' });
      });
      galSyncs.push(sync);
      sync();
    });
    function syncAllGals() {
      galSyncs.forEach(function (fn) { fn(); });
    }

    /* ================= Mobile media bars -> exclusive 1:1 drawers ================= Opening one closes any other open drawer (like the main dropdowns) and chase-scrolls its cluster into focus under the sticky menu. */
    Array.prototype.slice.call(root.querySelectorAll('[data-media-toggle]')).forEach(function (bar) {
      bar.addEventListener('click', function () {
        var set = bar.closest('[data-mat-set]');
        var dr = set ? set.querySelector('[data-media-drawer]') : null;
        if (!dr) return;
        var open = dr.classList.toggle('is-open');
        bar.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          Array.prototype.slice.call(root.querySelectorAll('[data-media-drawer].is-open')).forEach(function (o) {
            if (o === dr) return;
            o.classList.remove('is-open');
            var oset = o.closest('[data-mat-set]');
            var ob = oset ? oset.querySelector('[data-media-toggle]') : null;
            if (ob) ob.setAttribute('aria-expanded', 'false');
          });
          if (window.innerWidth < 768) chaseTo(set);
        }
        setTimeout(syncMedia, 280); // after the drawer settles, start/stop its videos
      });
    });

    /* The BUDGE: the first media bar in the visible category dips down once — a quick "you can open me" hint. Runs ~1s after the section scroll; once per bar per page view. */
    function nudgeActiveSet() {
      if (window.innerWidth >= 768) return; // mobile-only choreography
      var group = root.querySelector('[data-mat-group].is-active') || root.querySelector('[data-mat-group]');
      if (!group) return;
      var bar = group.querySelector('[data-media-toggle]');
      if (!bar || bar.getAttribute('data-nudged')) return;
      bar.setAttribute('data-nudged', '1');
      bar.classList.add('is-nudge');
      setTimeout(function () { bar.classList.remove('is-nudge'); }, 900);
    }

    /* ================= Main menu: right-edge fade + arrow while it can scroll ================= */
    var menuEl = root.querySelector('[data-menu]');
    if (menuEl) {
      var menuTabs = menuEl.querySelector('.pdp-dd__tabs');
      var moreBtn = menuEl.querySelector('[data-menu-more]');
      var menuSync = function () {
        var more = menuTabs.scrollWidth - menuTabs.clientWidth - menuTabs.scrollLeft > 6;
        menuEl.classList.toggle('is-more', more);
        if (moreBtn) moreBtn.hidden = !more;
      };
      menuTabs.addEventListener('scroll', menuSync);
      window.addEventListener('resize', menuSync);
      if (moreBtn) moreBtn.addEventListener('click', function () {
        menuTabs.scrollBy({ left: 160, behavior: 'smooth' });
      });
      menuSync();
    }

    /* ================= Designer quote — fade in on first sight ================= */
    var quoteEl = root.querySelector('[data-quote]');
    if (quoteEl) {
      if ('IntersectionObserver' in window) {
        var qio = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { quoteEl.classList.add('is-visible'); qio.disconnect(); }
          });
        }, { threshold: 0.35 });
        qio.observe(quoteEl);
      } else {
        quoteEl.classList.add('is-visible');
      }
    }

    /* ================= FAQ: small exclusive dropdowns inside the FAQ panel ================= */
    var faqItems = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));
    faqItems.forEach(function (item) {
      var q = item.querySelector('[data-faq-q]');
      if (!q) return;
      q.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          faqItems.forEach(function (o) {
            if (o === item) return;
            o.classList.remove('is-open');
            var ob = o.querySelector('[data-faq-q]');
            if (ob) ob.setAttribute('aria-expanded', 'false');
          });
        }
      });
    });

    /* ================= Spare parts: complementary products ================= The old additional-products behaviour: re-fetch THIS section through the product recommendations endpoint (intent=complementary, curated in Search & Discovery). If products come back, inject the cards and reveal the hidden category. */
    function initSpArrows() {
      var row = root.querySelector('[data-sp]');
      if (!row) return;
      var track = row.querySelector('[data-sp-cards]');
      var prev = row.querySelector('[data-sp-prev]');
      var next = row.querySelector('[data-sp-next]');
      function sync() {
        if (prev) prev.hidden = track.scrollLeft < 6;
        if (next) next.hidden = track.scrollLeft > track.scrollWidth - track.clientWidth - 6;
      }
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = null; sync(); });
      });
      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
      });
      sync();
    }
    var spUrl = root.getAttribute('data-sp-url');
    var spTrack = root.querySelector('[data-sp-cards]');
    if (spUrl && spTrack && window.fetch) {
      fetch(spUrl)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var remote = doc.querySelector('[data-sp-cards]');
          if (!remote || !remote.children.length) return;
          spTrack.innerHTML = remote.innerHTML;
          var st = root.querySelector('[data-sp-tab]');
          var sb = root.querySelector('[data-sp-block]');
          if (st) st.hidden = false;
          if (sb) sb.hidden = false;
          initSpArrows();
          window.dispatchEvent(new Event('resize')); // main-menu fade/arrow recheck
        })
        .catch(function () {});
    }

    /* ================= "Order samples" -> existing samples drawer (no fork) ================= */
    var samplesBtns = Array.prototype.slice.call(root.querySelectorAll('[data-open-samples]'));
    if (samplesBtns.length) {
      samplesBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var t = document.querySelector('.pdp-samples [data-samples-open]');
          if (t && !t.closest('.pdp-samples').classList.contains('is-open')) t.click();
        });
      });
      setTimeout(function () {
        if (!document.querySelector('.pdp-samples [data-samples-open]')) {
          samplesBtns.forEach(function (btn) { btn.hidden = true; });
        }
      }, 1500);
    }
    }

    /* ================= Initial boot =================
       2026-11-02 perf: this file used to be an inline script at the end of
       sections/pdp-description.liquid and found its root through document.currentScript. As a
       cached, deferred asset it runs once after parsing and boots every panel on the page. */
    var roots = document.querySelectorAll('[data-pdp-dd]');
    Array.prototype.forEach.call(roots, boot);

    /* ================= Colourway swatch swap =================
      THE PROBLEM. The colourway swatches carry data-action="handle-reload". QuickLoad (in
      global.js, which is not ours to edit) intercepts that click and swaps the product in place
      without a page load — but its replaceClasses list is only ["section__product-module",
      "product-info"]. This section is not in that list, so after clicking from Black Oak to Oak
      the title, price and gallery updated while this whole panel still described Black Oak.
      Direct URL loads were always correct, which is why it only showed up when browsing on-site.

      THE FIX. Same idea as the per-variant dimension rows, one level up: instead of swapping by
      variant we re-render by sibling product. We ask Shopify for THIS section rendered for the
      clicked product (Section Rendering API) and replace our own markup with the response, so
      the content is always server truth and can never drift from the product it claims to
      describe. Nothing here touches global.js.

      Scripts parsed by DOMParser never execute, so the incoming script tag stays inert and boot()
      is called by hand on the new node — no double binding.

      DO NOT write a literal script or style tag (with angle brackets) anywhere inside this file's
      comments. Even inside a Liquid comment, and even inside this script block, theme-check's
      LiquidHTML parser treats it as opening a raw-text node: the real closing tag then closes
      THAT one, the outer script never closes, and the whole file fails to parse with
      'SyntaxError: expected "</"' pointing at the last line. Shopify still renders the page, so
      the only symptom is that theme-check goes silent on this file. Spell the tag out in words.

      KNOWN COST: boot() attaches two document-level listeners (keydown for the diagram zoom,
      change for the variant spec rows). Re-booting adds a fresh pair per swap. They must
      re-bind, because the old ones close over the detached previous root and would otherwise
      keep updating markup nobody can see. The stale ones then operate on a detached node, which
      is harmless but not free. A shopper clicking a handful of swatches leaves a handful behind;
      a full page load clears them. Worth revisiting only if a page ever swaps dozens of times. */
    /* The section id comes from Shopify's own wrapper (shopify-section-<id>) around the first panel. */
    var ddWrap = roots[0] && roots[0].closest('[id^="shopify-section-"]');
    var DD_SECTION_ID = ddWrap ? ddWrap.id.slice('shopify-section-'.length) : '';

    if (!window.__pdpDdSwapBound) {
      window.__pdpDdSwapBound = true;

      document.addEventListener('click', function (e) {
        var link = e.target && e.target.closest && e.target.closest('[data-action="handle-reload"]');
        if (!link) return;

        var href = link.getAttribute('href');
        if (!href) return;

        var wrap = DD_SECTION_ID && document.getElementById('shopify-section-' + DD_SECTION_ID);
        if (!wrap) return;

        var current = wrap.querySelector('[data-pdp-dd]');
        if (!current) return;

        /* Strip any existing query/hash before adding section_id — the swatch href
          can arrive collection-scoped (/collections/x/products/y) and that form is fine. */
        var base = href.split('#')[0].split('?')[0];
        var url = base + '?section_id=' + encodeURIComponent(DD_SECTION_ID);

        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
          .then(function (html) {
            var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pdp-dd]');
            var live = wrap.querySelector('[data-pdp-dd]');
            if (!fresh || !live || !live.parentNode) return;
            live.parentNode.replaceChild(fresh, live);
            boot(fresh);
          })
          .catch(function () {
            /* Network or 404: leave the existing panel alone. Stale beats blank, and
              QuickLoad has already updated the product module either way. */
          });
      }, true);
    }
  })();
